import { render } from "./InternalDirectoryShow.vue?vue&type=template&id=45fcf7c2"
import script from "./InternalDirectoryShow.vue?vue&type=script&setup=true&lang=js"
export * from "./InternalDirectoryShow.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Internal/Directory/InternalDirectoryShow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45fcf7c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45fcf7c2', __exports__)) {
    api.reload('45fcf7c2', __exports__)
  }
  
  module.hot.accept("./InternalDirectoryShow.vue?vue&type=template&id=45fcf7c2", () => {
    api.rerender('45fcf7c2', render)
  })

}


export default __exports__